var _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFermeture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 125 100",
    viewBox: "0 0 125 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EE7203;}\r\n\t.st1{fill:#000000;}\r\n")), /*#__PURE__*/React.createElement("g", {
    fill: "#EE7203",
    stroke: "#EE7203",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50.907 39.17h23.168",
    strokeWidth: 3.0273,
    style: {
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m73.857 46.092 0.07865-6.607",
    style: {
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.43 43.181v-3.3035",
    style: {
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.553 47.193 0.07866-7.0789",
    style: {
      paintOrder: "stroke fill markers"
    }
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.417,
    cy: 40.743,
    rx: 6.6857,
    ry: 6.5283,
    fill: "none",
    stroke: "#EE7203",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.7,
    style: {
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.63 84.397v-70.553h55.688v72.992",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.7,
    style: {
      paintOrder: "stroke fill markers"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFermeture);
export default __webpack_public_path__ + "static/media/fermeture.7746115950aae48bcb02636f8ae4a7dd.svg";
export { ForwardRef as ReactComponent };